import * as React from 'react';
import * as ReactDOM from 'react-dom';
import * as I18n from 'i18n-js';
import { InMemoryCache } from 'apollo-cache-inmemory';
import * as elog from '@reverbdotcom/elog';
import { AppProvider, buildApolloClient } from '@reverbdotcom/discovery-ui';

let hot;
if (process.env.NODE_ENV !== 'production') {
  hot = require('react-hot-loader').hot;
}

import token from './auth_token';
import { parseMeta } from './parse_meta';
import { get } from 'lodash';

const init = (global, dom) => {
  const CLASS_NAME_ATTR = 'data-react-class';
  const PROPS_ATTR = 'data-react-props';

  const state = parseMeta('apollo-state');
  const user = get(parseMeta('current-user'), 'user');

  const client = buildApolloClient(user, token);
  client.restore(state);

  const all = dom.querySelectorAll('[data-react-class]');
  [].forEach.call(all, (component) => { // querySelectorAll returns a NodeList not an []
    try {
      const name = component.getAttribute(CLASS_NAME_ATTR);
      const props = component.getAttribute(PROPS_ATTR);
      const parsed = JSON.parse(props);

      const constructor = name
        .split('.')
        .reduce((obj, index) => obj[index], global);

      if (!constructor) {
        throw new Error(`Could not find React component ${name}`);
      }

      let wrappedConstructor = constructor;
      if (process.env.NODE_ENV !== 'production') {
        wrappedConstructor = hot(module)(constructor);
      }

      const componentElement = React.createElement(wrappedConstructor, parsed);


      const wrapped = React.createElement(
        AppProvider,
        {
          user,
          client,
        },
        componentElement,
      );

      ReactDOM.render(wrapped, component);
    } catch (e) {
      console.error(e);
    }
  });
};

export default {
  init,
};

document.addEventListener('DOMContentLoaded', init.bind(this, window, document));



// WEBPACK FOOTER //
// ./javascripts/components/react_ujs.js